import { ParametrosDeAtualizacaoCanaldeVendas } from "@/models"
import type { CanalDeVendasServiceAdapter } from "./adapter"
import { Inject } from 'inversify-props'

export class SaveCanalDeVendasUseCase {
	@Inject('CanalDeVendasServiceAdapter')
	private canalDeVendasAdapter!: CanalDeVendasServiceAdapter

	create = async (parametros: ParametrosDeAtualizacaoCanaldeVendas) => await this.canalDeVendasAdapter.create(parametros)
	update = async (parametros: ParametrosDeAtualizacaoCanaldeVendas) => await this.canalDeVendasAdapter.update(parametros)
}
